import React, { useState, useEffect } from "react";
import { Button, Checkbox } from "antd";
import { PiMicrosoftExcelLogoThin } from "react-icons/pi";
import * as XLSX from "xlsx";
import "../../style.css";

const ExportTarefasPendentesEmitidas = ({ slicedData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allFields, setAllFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [filterStatus] = useState("todos");

  // Labels amigáveis
  const fieldLabels = {
    "cliente.id" : "ID do Cliente",
    "cliente.cnpj" : "CNPJ do cliente",
    "cliente.nome" : "Razão Social",
    "cliente.tipoPessoa" : "Tipo de pessoa",
    "cliente.ie" : "Inscrição Estadual",
    "cliente.im" : "Inscrição Municipal",
    "cliente.regimeTributario.id" : "Regime Tributário",
    "cliente.segmentoEmpresa.nome" : "Segmento da Empresa",
    "cliente.cnaeAnexos" : "CNAE Anexos",
    "cliente.carteira.id" : "Carteira",
    "cliente.equipe.id" : "Equipe",
    "obrigacao.id" : "ID Obrigação",
    "obrigacao.sigla" : "Sigla",
    "obrigacao.nome" : "Obrigação",
    "obrigacao.prazo" : "Prazo",
    "obrigacao.ambito" : "Âmbito",
    "obrigacao.dia" : "Dia",
    "obrigacao.deslocamentoVencimento" : "Deslocamento vencimento",
    quantidadeEmitido : "Quantidade emitida",
    quantidadeEmitidoForaPrazo : "Quantidade emitidas fora do Prazo",
    quantidadeEmitidosDia : "Quantidade emitidas por dia",
    quantidadePrevisto: "Quantidade previsto"
  };

  // Flatten do objeto
  const flattenObject = (obj, prefix = "") => {
    const result = {};
    for (const key in obj) {
      const value = obj[key];
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        Object.assign(result, flattenObject(value, newKey));
      } else {
        result[newKey] = value;
      }
    }
    return result;
  };

  // Captura todos os campos do objeto
  useEffect(() => {
    if (slicedData.length > 0) {
      const flatKeys = Object.keys(flattenObject(slicedData[0]));
      setAllFields(flatKeys);
    }
  }, [slicedData]);

  // Define campos visíveis e escondidos
  const visibleFields = allFields.filter(field => Object.keys(fieldLabels).includes(field));

  // Exporta para Excel
  const handleExport = () => {
    if (selectedFields.length === 0) {
      alert("Selecione pelo menos uma coluna!");
      return;
    }

    // Filtra dados pelo status
    const filteredData = slicedData.filter((item) => {
      if (filterStatus === "finalizadas") return item.quantidadePrevisto === item.quantidadeEmitido;
      if (filterStatus === "pendentes") return item.quantidadePrevisto !== item.quantidadeEmitido;
      return true;
    });

    const dataForExcel = filteredData.map((item) => {
      const flat = flattenObject(item);
      const row = {};
      selectedFields.forEach((field) => {
        row[fieldLabels[field] || field] = flat[field] ?? "";
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tabela de Tarefas Contábil");
    XLSX.writeFile(workbook, "Tabela_de_Tarefas_Contabil.xlsx");

    setIsModalOpen(false);
  };

  return (
    <>
      <div className="flex-excel">
        <div className="excel">
          <PiMicrosoftExcelLogoThin />
        </div>
      </div>

      <Checkbox
        checked={selectedFields.length === visibleFields.length}
        onChange={(e) =>
          setSelectedFields(e.target.checked ? visibleFields : [])
        }
      >
        Selecionar Todos
      </Checkbox>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "8px",
          marginTop: "10px",
        }}
      >
        {visibleFields.map((field) => (
          <Checkbox
            key={field}
            checked={selectedFields.includes(field)}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedFields((prev) =>
                checked ? [...prev, field] : prev.filter((f) => f !== field)
              );
            }}
          >
            {fieldLabels[field] || field}
          </Checkbox>
        ))}
      </div>

      <Button type="primary" onClick={handleExport} style={{ marginTop: "20px" }}>
        Exportar
      </Button>
    </>
  );
};

export default ExportTarefasPendentesEmitidas;
